import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Api from '../../services/ApiService';
import Socket from '../../services/SocketService';

class ChatBuffer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      buffer: [],
    };

    this.addMessage = this.addMessage.bind(this);
    this.syncBuffer = this.syncBuffer.bind(this);
  }

  componentDidMount() {
    const { room } = this.props;

    this.syncBuffer();

    Socket.chat
      .on('connect', this.syncBuffer)
      .on(`${room}.message`, this.addMessage);

    this.scrollToBottom();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  componentWillUnmount() {
    Socket.chat
      .off('connect', this.syncBuffer)
      .off(`${this.props.room}.message`, this.addMessage);
  }

  addMessage(message) {
    const { buffer } = this.state;
    buffer.push(message);
    this.setState({ buffer });
  }

  syncBuffer() {
    const { room } = this.props;

    Api.get(`chat/room/${room}`).then((res) => {
      const { buffer = [] } = res.data;

      const stateBuffer = [];
      // quickly reverse order
      for (let i = buffer.length - 1; i >= 0; i -= 1) {
        try {
          stateBuffer.push(JSON.parse(buffer[i]));
        } catch (e) {
          // filter out malformed junk
          console.log(e.message);
        }
      }

      this.setState({ buffer: stateBuffer });
    });
  }

  scrollToBottom() {
    if (this.messageEnd) {
      this.messageEnd.scrollIntoView({ behavior: 'smooth' });
    }
  }

  renderBuffer() {
    const { room } = this.props;

    return this.state.buffer.map((line, i) => {
      return (
        <div key={`chat-buffer-${room}-${i}`}>
          <span>{line.username}</span>: {line.message}
        </div>
      );
    });
  }

  render() {
    return (
      <div className="buffer">
        <div className="buffer-head">#{this.props.room}</div>
        <div className="buffer-body">
          {this.renderBuffer()}
        </div>
        <div
          style={{ float: 'left', clear: 'both' }}
          ref={(el) => { this.messageEnd = el; }}
        />
      </div>

    );
  }
}

ChatBuffer.propTypes = {
  room: PropTypes.string,
};

export default ChatBuffer;
